<template>
  <v-app>
    <v-container fluid>
      <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel3">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Project Budget Details
                                List</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="12">
                                        <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search"
                                            single-line hide-details density="compact" variant="outlined"
                                            bg-color="grey-lighten-4" class="pl-2" clearable></v-text-field>
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                                                    @click="exportToCSV">CSV</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                                                    @click="exportToExcel">EXCEL</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red"
                                                    @click="exportToPDF">PDF</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <div class="text-right pr-2">
                                            <v-btn v-if="checkInsertAccess()"
                                                @click="goToBudgetDetails" color="primary" variant="tonal"
                                                prepend-icon="mdi mdi-plus" rounded="xl">
                                                Add Budget Cost
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-data-table :headers="headers" :items="getBudgetCostList" :loading="loading"
                                    v-model:items-per-page="itemsPerPage" :search="search" :hover="true"
                                    density="compact">

                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.budget_cost_date="{ item }">
                                        {{ formatDate(item.budget_cost_date) }}
                                    </template>

                                    <template v-slot:item.budget_amount="{ item }">
                                        {{ formatCurrency(item.budget_amount) }}
                                    </template>

                                    <template v-slot:item.created_by.full_name="{ item }">
                                        {{ item.created_by?.full_name || 'N/A' }}
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <v-chip v-if="item.status == 1" color="success" size="small"
                                            class="text-capitalize">Active</v-chip>
                                        <v-chip v-else color="red" size="small"
                                            class="text-capitalize">Inactive</v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon class="me-2 edit-button" color="primary" @click="editItem(item)"
                                            v-if="$updateAccess($route.path)">
                                            mdi mdi-pencil-outline
                                        </v-icon>
                                        <v-icon class="me-2 edit-button" color="red" @click="deleteItem(item)"
                                            v-if="$updateAccess($route.path)">
                                            mdi mdi-delete-outline
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProjectBudgetCostList',

  data() {
    return {
      itemsPerPage: 50,
      panel: [0],
      panel3: [0],
      loading: false,
      search: "",

      headers: [
        { title: '#SL', align: 'center', key: 'index', width: '7%', sortable: false },
        { title: 'Code', key: 'budget_cost_code', align: 'left', sortable: false },
        { title: 'Date', key: 'budget_cost_date', align: 'left', sortable: false },
        { title: 'Project', key: 'project.name', align: 'left', sortable: false },
        { title: 'Budget Amount', key: 'budget_amount', align: 'right', sortable: false },
        { title: 'Created By', key: 'created_by.full_name', align: 'left', sortable: false },
        { title: 'Status', key: 'status', align: 'center', sortable: false },
        { title: 'Actions', key: 'actions', width: '150px', sortable: false },
      ],
    };
  },

  computed: {
    getBudgetCostList() {
      return this.$store.getters.getProjectBudgetDetailList;
    },
  },

  mounted() {
    // Load initial data
    if (this.$store.getters.getProjectBudgetDetailList.length == 0) {
      this.$store.dispatch('getProjectBudgetDetailList');
    }
  },

  methods: {
    async editItem(item) {
      try {
        this.loading = true;
        // Fetch complete record with budgetCostDetails relationship
        const response = await this.$store.dispatch('getBudgetCostById', item.id);

        // Store complete data in localStorage
        localStorage.setItem('budgetCostEditData', JSON.stringify(response.data));

        // Navigate to project budget details page
        this.$router.push({
          name: 'project-budget-details'
        });
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Failed to load budget cost details');
        console.error('Error loading budget cost details:', error);
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      const confirm = await this.$confirm(
        'Are you sure you want to delete this budget cost record?',
        'Delete Confirmation'
      );

      if (confirm) {
        try {
          await this.$store.dispatch('deleteProjectBudgetDetail', item.id);
          this.$toast.success('Budget cost deleted successfully');
          this.$store.dispatch('getProjectBudgetDetailList');
        } catch (error) {
          this.$toast.error('Failed to delete budget cost');
          console.error('Error deleting budget cost:', error);
        }
      }
    },

    closeDialog() {
      this.dialog = false;
      this.selectedItem = null;
      this.isEdit = false;
    },

    onSaved() {
      this.closeDialog();
      this.$store.dispatch('getProjectBudgetDetailList');
    },

    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString();
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '';
      return new Date(dateTime).toLocaleString();
    },

    formatCurrency(amount) {
      if (!amount) return '0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(amount);
    },

    exportToCSV() {
      // Implementation for CSV export
      this.$toast.info('CSV export functionality will be implemented');
    },

    exportToExcel() {
      // Implementation for Excel export
      this.$toast.info('Excel export functionality will be implemented');
    },

    exportToPDF() {
      // Implementation for PDF export
      this.$toast.info('PDF export functionality will be implemented');
    },

    goToBudgetDetails() {
      this.$router.push({ name: 'project-budget-details' });
    },

    checkInsertAccess() {
      return this.$insertAccess ? this.$insertAccess('/project/project-budget-cost-list') : false;
    },

  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>